// extracted by mini-css-extract-plugin
module.exports = {"menu-items":"menuItems-m__menu-items__1Gi4m"};